import Loader from '@jobseeker/lotus/components/Loader';
import {Box} from '@mui/material';
import React, {useEffect, useRef} from 'react';

type InfinitePaginationProps = {
  children: React.ReactNode;
  hasMore: boolean;
  isLoading: boolean;
  onLoadMore: () => void;
};

const InfinitePagination: React.FC<InfinitePaginationProps> = ({
  children,
  hasMore,
  isLoading,
  onLoadMore,
}) => {
  const loaderRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!hasMore) return;

    const observer = new IntersectionObserver(
      entries => {
        const target = entries[0];
        if (target.isIntersecting && !isLoading) {
          onLoadMore();
        }
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.5,
      }
    );

    const loaderElement = loaderRef.current;

    if (!loaderElement) {
      return;
    }

    observer.observe(loaderElement);

    return () => {
      observer.unobserve(loaderElement);
    };
  }, [hasMore, isLoading, onLoadMore]);

  return (
    <Box>
      {children}

      {hasMore && (
        <Box ref={loaderRef} className="loader">
          {isLoading ? <Loader /> : ''}
        </Box>
      )}
    </Box>
  );
};

export default InfinitePagination;
